import styles from "./LotteryRoulette.module.scss"

// 1 発の花火で飛ばす火の粉の数.
const SPARK_COUNT = 14

// 火の粉の色. 色の値そのものは scss に置き、ここでは順番だけ決める (紙吹雪と同じ方針).
const SPARK_COLOR_CLASS_NAMES = [
	styles.sparkGold,
	styles.sparkPink,
	styles.sparkGoldPale,
]

export type Firework = {
	id: number
	// 花火が開く位置. ルーレットの面の左上からの割合 (%) と距離 (px).
	xPercent: number
	y: number
	// 止まってから開くまでの時間 (ms). 音の「ドン」もこの時刻に合わせて鳴らす.
	delayMs: number
	// 火の粉が飛ぶ距離 (px)
	radius: number
}

// 花火を上げる位置とタイミング. 盤面の左上・右上・中央上の順に、少しずつずらして開く.
// y は盤面の中心 (originY) からの相対位置で決めるので、見出しの行数が変わっても盤面の周りに開く.
export const newFireworks = (originY: number): Firework[] => [
	{ id: 0, xPercent: 20, y: originY - 90, delayMs: 250, radius: 62 },
	{ id: 1, xPercent: 82, y: originY - 60, delayMs: 600, radius: 70 },
	{ id: 2, xPercent: 50, y: originY - 150, delayMs: 950, radius: 84 },
	{ id: 3, xPercent: 14, y: originY + 70, delayMs: 1300, radius: 56 },
	{ id: 4, xPercent: 88, y: originY + 90, delayMs: 1600, radius: 60 },
]

// scss の @keyframes lottery-spark が読む CSS 変数.
type SparkStyle = React.CSSProperties & {
	"--angle": string
	"--radius": string
}

const sparkStyle = (firework: Firework, index: number): SparkStyle => ({
	"--angle": `${(360 / SPARK_COUNT) * index}deg`,
	"--radius": `${firework.radius}px`,
	animationDelay: `${firework.delayMs}ms`,
})

const sparkIndexes = Array.from({ length: SPARK_COUNT }, (_, index) => index)

type Props = {
	fireworks: Firework[]
}

// 止まった後に盤面の周りで開く花火. 見た目だけの装飾なので読み上げない.
const LotteryFireworks = ({ fireworks }: Props) => {
	return (
		<div className={styles.fireworks} aria-hidden="true">
			{fireworks.map((firework) => (
				<div
					key={firework.id}
					className={styles.firework}
					style={{ left: `${firework.xPercent}%`, top: `${firework.y}px` }}
				>
					{sparkIndexes.map((index) => (
						<span
							key={index}
							className={`${styles.spark} ${SPARK_COLOR_CLASS_NAMES[index % SPARK_COLOR_CLASS_NAMES.length]}`}
							style={sparkStyle(firework, index)}
						/>
					))}
				</div>
			))}
		</div>
	)
}

export default LotteryFireworks
